module.exports = __webpack_public_path__ + "media/theme/border-5-dfbef639.png";